import { lazy, memo, Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import LayoutClient from 'src/layouts/layout';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import RouteGuard from 'src/routes/guard';
import { Routes as Router } from 'src/routes/route';
import InitAppProvider from './initApp.provider';

const Page404Screen = lazy(() => import('src/screens/errors/page404'));
const Page500Screen = lazy(() => import('src/screens/errors/page500'));
const Page403Screen = lazy(() => import('src/screens/errors/page403'));

const LoginScreen = lazy(() => import('src/screens/auth/login/index'));

const DashboardScreen = lazy(() => import('src/screens/dashboard'));
const NhanVienScreen = lazy(() => import('src/screens/nhan-vien'));
const BangLuongScreen = lazy(() => import('src/screens/bang-luong'));
const PhanHoiLuongScreen = lazy(() => import('src/screens/phan-hoi-luong'));

function RouteProvider() {
  return (
    <Routes>
      <Route
        element={
          <InitAppProvider>
            <RouteGuard>
              <LayoutClient />
            </RouteGuard>
          </InitAppProvider>
        }
      >
        <Route index element={<DashboardScreen />} />
        <Route path={Router.NHAN_VIEN.path} element={<NhanVienScreen />} />
        <Route path={Router.BANG_LUONG.path} element={<BangLuongScreen />} />
        <Route path={Router.PHAN_HOI_LUONG.path} element={<PhanHoiLuongScreen />} />
      </Route>

      <Route
        element={
          <Suspense fallback={<SpinnerLoader bg={false} />}>
            <Outlet />
          </Suspense>
        }
      >
        <Route path={Router.LOGIN.path} element={<LoginScreen />} />

        <Route path={Router.PAGE500.path} element={<Page500Screen />} />
        <Route path={Router.PAGE403.path} element={<Page403Screen />} />

        <Route path="*" element={<Page404Screen />} />
      </Route>
    </Routes>
  );
}

export default memo(RouteProvider);
